import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { IFormPayload } from 'pages/signup'

type UseFillEmailProps = {
  aol?: boolean
  formEmail?: string
  setValues: UseFormSetValue<IFormPayload>
}

export const useFillEmail = ({ aol, formEmail, setValues }: UseFillEmailProps) => {
  const router = useRouter()
  const emailQuery = router.query.email
  const email = typeof emailQuery === 'string' ? emailQuery : undefined
  const isFormEmailEmpty = formEmail == null || formEmail === ''

  useEffect(() => {
    if (email != null && aol && isFormEmailEmpty) {
      setValues('email', email)
    }
  }, [aol, email, setValues, isFormEmailEmpty])
}
